module.exports = __webpack_public_path__ + "img/border1.7b3cbe09.png";